import React, { Component } from "react";
import { connect } from 'react-redux';

import PageHelmet from "../../component/common/Helmet";
import Breadcrumb from "../../elements/common/Breadcrumb";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer";
import Tab from "../../elements/tab/ContactTab";

import { getAllCountries, getAllBranches } from '../../redux/actions';

class Contact extends Component{

    componentDidMount() {
        const { getAllCountries, getAllBranches } = this.props;
        getAllCountries({offset: 0, limit: 100});
        getAllBranches({offset: 0, limit: 100});
    }

    render(){
        const { countries, branches } = this.props;
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Contact' />

                 {/* Start Header Area  */}
                <Header headerPosition="header--static logoresize" logo="all-dark" color="color-black"/>
                {/* End Header Area  */}
                
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'Contact'}   />
                {/* End Breadcrump Area */}


                {/* Start Blog Area */}
                <div className="rn-blog-area ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row mt--20">
                            <div className="col-lg-12">
                                {/* Start Pagination Area */}
                                <Tab countries={countries} branches={branches} />
                                {/* End Pagination Area */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Blog Area */}
                
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer /> 

            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const { countries } = state.Country;
    const { branches } = state.Branch;

    return { countries, branches };
};

export default connect(mapStateToProps, { getAllCountries, getAllBranches })(Contact);
